module.exports = __webpack_public_path__ + "img/top_background.7fd35dbf.jpg";